'use strict';

module.exports = function (input) {
  return input.replace(/\.{3}/gim, '…');
};

